import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import "./i18n/config.js";

import "antd/dist/reset.css";
import { ConfigProvider, App as AntdApp, theme as antdTheme } from "antd";
import { Provider, useSelector } from "react-redux";
import { store } from "./store/store.js";
import { SocketProvider } from "./messagerie/context/SocketContext.jsx";
import { ThemeProvider, useTheme } from "./places/context/ThemeContext.jsx";
import MedicationToastBridge from "./notifications/components/MedicationToastBridge.jsx";
import RendezvousToastBridge from "./notifications/components/RendezvousToastBridge.jsx";

function ThemedAntdProvider({ children }) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const antdConfig = React.useMemo(
    () => ({
      theme: {
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: "#006eea ",
          borderRadius: 6,
        },
      },
    }),
    [isDark]
  );

  return (
    <ConfigProvider {...antdConfig}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}

/* ------------------------- Render ------------------------- */
ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ThemeProvider>
      <ThemedAntdProvider>
        <SocketProvider> 
      <RendezvousToastBridge />
      <MedicationToastBridge />          
      <App />
      </SocketProvider>
      </ThemedAntdProvider>
    </ThemeProvider>
  </Provider>
);
